import type { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const NotFoundPage = lazy(() => import('../../pages/NotFoundPage'));
const AccessDenied = lazy(() => import('@cobliteam/ui-business/components/AccessDenied'));

const routes = [
  {
    path: '/not-found' as Location,
    component: NotFoundPage,
  },
  {
    path: '/access-denied' as Location,
    component: AccessDenied,
  },
];

export default routes;
